import React, { useEffect, useState } from 'react';
import axios from 'axios';
import WallOfFame from '../components/Awards/WallOfFame';
import './WallOfFameSection.css';

const API = process.env.REACT_APP_API_BASE_URL;

/* Home page: our students' badges and medals of this month and last month (short names only).
   Hidden while nobody has one. Data: /api/public/showcase/wall (no login). */
const WallOfFameSection = () => {
  const [feed, setFeed] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/api/public/showcase/wall`)
      .then((res) => alive && setFeed(res.data?.feed || []))
      .catch(() => alive && setFeed([]));
    return () => {
      alive = false;
    };
  }, []);

  if (!feed || feed.length === 0) return null;

  return (
    <section className="rmhwf" aria-labelledby="rmhwf-title">
      <div className="rmhwf-wrap">
        <p className="rmhwf-kicker">Proud of our students</p>
        <h2 id="rmhwf-title" className="rmhwf-title">
          This month’s stars at RoboMind
        </h2>
        <p className="rmhwf-sub">Badges and challenge medals our students and teachers earned this month and last month.</p>
        <WallOfFame items={feed} className="rmhwf-card" />
      </div>
    </section>
  );
};

export default WallOfFameSection;
